import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotWorks from "./components/HotWorks";
import Categories from "./components/Categories";
import Latest from "./components/Latest";
import Reputation from "./components/Reputation";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

// FAQPage 结构化数据（与页面正文 FAQ 完全一致）
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "什么是火影同人动漫？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "火影同人动漫是指由粉丝基于《火影忍者》世界观二次创作的动画、漫画与小说作品，保留原作角色与忍界设定，剧情走向更自由，常加入穿越、系统、重生等脑洞设定。",
      },
    },
    {
      "@type": "Question",
      name: "站内作品多久更新一次？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "热门连载作品基本保持每日或隔日更新，作品卡片与追更榜单会标注最近更新时间，用户还可收藏作品并订阅追更提醒。",
      },
    },
    {
      "@type": "Question",
      name: "穿越、系统、重生这些分类有什么区别？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "穿越类指主角从现代或异时空进入火影世界；系统类指主角绑定金手指系统辅助成长；重生类指主角带着记忆重新经历人生；战斗类侧重忍术对决与燃向剧情；剧情类围绕原作脉络展开。",
      },
    },
    {
      "@type": "Question",
      name: "需要付费才能观看吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "站内大部分火影同人作品均可免费在线阅读，部分精品长篇连载设有会员抢先看与免广告权益，新用户注册即可领取限时免费阅读券。",
      },
    },
    {
      "@type": "Question",
      name: "如何提交自己的同人创作？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "创作者可在联系方式表单中留下作品简介与样章投稿，审核通过的作品将有机会登上推荐位与追更榜单并获得流量扶持。",
      },
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <Hero />
      <HotWorks />
      <Categories />
      <Latest />
      <Reputation />
      <Faq />
      <Contact />
      <Footer />
      <BackToTop />
    </main>
  );
}